import React from 'react';
import Header from "./header";
import AboutMe from "./about-me";
import AboutCourse from "./about-course";
import {packageInfo} from "../data/mock-date";
import Package from "./packeges";
import MiniHeaders from "./mini-headers";
import HowRegister from "./how-register";
import OtherServices from "./other-services";
import Faq from "./faq";
import CourseOutline from "./course-outline";
import WhyWB from "./why-wb";
import OurServices from "./our-services";
import TrainingCourse from "./training-course";
import ScrollToTop from "./scroll-top";

const MainPage = () => {
    return (
        <div>
            <Header/>
            <div className={'wrapper-main-content'}>
                <AboutCourse/>
                <AboutMe/>
                <TrainingCourse/>
                <div className={'blocks-wrapper'}>
                    <MiniHeaders headerName={'Փաթեթներ'}/>
                    {
                        packageInfo.map((item, index) => {
                            return (
                                <Package key={index} packageObj={item}/>
                            )
                        })
                    }

                </div>

                <CourseOutline/>
                <HowRegister/>
                <Faq/>
                <WhyWB/>
                <OurServices/>
                <OtherServices/>
                <ScrollToTop/>
            </div>
        </div>
    );
};

export default MainPage;
